<template>
  <div class="complaint-detail-container">
    <div class="page-content">
      <!-- 面包屑 -->
      <div class="breadcrumb">
        <span class="breadcrumb-parent">{{ $t('complaintDetail.breadcrumbParent') }}</span>
        <i class="el-icon-arrow-right"></i>
        <span class="breadcrumb-current">{{ $t('complaintDetail.title') }}</span>
      </div>

      <!-- 返回按钮 -->
      <el-button class="back-btn" @click="goBack">
        {{ $t('common.back') }}
      </el-button>

      <!-- 详情信息 -->
      <div class="detail-card">
        <div class="detail-row">
          <div class="detail-item">
            <span class="detail-label">{{ $t('complaintDetailInfo.orderNo') }}：</span>
            <span class="detail-value">{{ complaintDetailInfo.complaintId }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">{{ $t('complaintDetailInfo.type') }}：</span>
            <span class="detail-value">{{ complaintDetailInfo.typeName }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">{{ $t('complaintDetailInfo.status') }}：</span>
            <span class="detail-value">{{ complaintDetailInfo.stateName }}</span>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-item">
            <span class="detail-label">{{ $t('complaintDetailInfo.house') }}：</span>
            <span class="detail-value">{{ complaintDetailInfo.roomName }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">{{ $t('complaintDetailInfo.contact') }}：</span>
            <span class="detail-value">{{ complaintDetailInfo.complaintName }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">{{ $t('complaintDetailInfo.phone') }}：</span>
            <span class="detail-value">{{ complaintDetailInfo.tel }}</span>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-item">
            <span class="detail-label">{{ $t('complaintDetailInfo.createTime') }}：</span>
            <span class="detail-value">{{ complaintDetailInfo.createTime }}</span>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-item detail-item-full">
            <span class="detail-label">{{ $t('complaintDetailInfo.content') }}：</span>
            <span class="detail-value">{{ complaintDetailInfo.context }}</span>
          </div>
        </div>
      </div>

      <!-- Tab 页签 -->
      <div class="tabs-wrapper">
        <el-tabs v-model="complaintDetailInfo._currentTab" @tab-click="changeTab(complaintDetailInfo._currentTab)">
          <el-tab-pane :label="$t('complaintDetail.workflow')" name="complaintDetailEvent">
            <complaint-detail-event v-if="complaintDetailInfo._currentTab === 'complaintDetailEvent'"
              ref="complaintDetailEvent" />
          </el-tab-pane>
          <el-tab-pane :label="$t('complaintDetail.evaluation')" name="complaintDetailAppraise">
            <complaint-detail-appraise v-if="complaintDetailInfo._currentTab === 'complaintDetailAppraise'"
              ref="complaintDetailAppraise" />
          </el-tab-pane>
          <el-tab-pane :label="$t('complaintDetail.type')" name="complaintDetailType">
            <complaint-detail-type v-if="complaintDetailInfo._currentTab === 'complaintDetailType'"
              ref="complaintDetailType" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import ComplaintDetailEvent from '@/components/oa/ComplaintDetailEvent'
import ComplaintDetailAppraise from '@/components/oa/ComplaintDetailAppraise'
import ComplaintDetailType from '@/components/oa/ComplaintDetailType'
import { getComplaintDetail } from '@/api/oa/complaintDetailApi'

export default {
  name: 'ComplaintDetailList',
  components: {
    ComplaintDetailEvent,
    ComplaintDetailAppraise,
    ComplaintDetailType
  },
  data() {
    return {
      complaintDetailInfo: {
        viewComplaintFlag: '',
        complaintId: '',
        typeName: '',
        typeCd: '',
        roomName: '',
        complaintName: '',
        tel: '',
        stateName: '',
        createTime: '',
        context: '',
        _currentTab: 'complaintDetailEvent'
      }
    }
  },
  created() {
    this.complaintDetailInfo.complaintId = this.$route.query.complaintId
    if (!this.complaintDetailInfo.complaintId) {
      return
    }
    const currentTab = this.$route.query.currentTab
    if (currentTab) {
      this.complaintDetailInfo._currentTab = currentTab
    }
    this.loadComplaintInfo()
  },
  methods: {
    async loadComplaintInfo() {
      try {
        const params = {
          complaintId: this.complaintDetailInfo.complaintId,
          page: 1,
          row: 1,
          ownerTypeCd: '1001'
        }
        const { data } = await getComplaintDetail(params)
        if (data && data.length > 0) {
          Object.assign(this.complaintDetailInfo, data[0])
        }
      } catch (error) {
        console.error('获取投诉详情失败:', error)
      }
    },
    changeTab(tab) {
      this.complaintDetailInfo._currentTab = tab
      setTimeout(() => {
        if (this.$refs[tab]) {
          this.$refs[tab].initData({
            complaintId: this.complaintDetailInfo.complaintId,
            typeCd: this.complaintDetailInfo.typeCd
          })
        }
      }, 500)
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.complaint-detail-container {
  padding: 20px;
  background-color: #EBF2FA;
  min-height: calc(100vh - 84px);
  font-family: 'PingFang SC', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;

  .page-content {
    background: #FFFFFF;
    border-radius: 12px;
    padding: 22px 24px;
    position: relative;
  }

  .breadcrumb {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 20px;
    font-size: 16px;
    font-family: 'PingFang SC', sans-serif;
    font-weight: 600;

    .breadcrumb-parent {
      color: #8C9BB4;
    }

    .breadcrumb-current {
      color: #1D2129;
    }

    i {
      color: #8C9BB4;
      font-size: 12px;
    }
  }

  .back-btn {
    position: absolute;
    top: 22px;
    right: 24px;
    width: 78px;
    height: 38px;
    border-radius: 10px;
    background: #FFFFFF;
    border: 1px solid #0E76FF;
    color: #0E76FF;
    font-size: 14px;
    font-family: 'PingFang SC', sans-serif;
    font-weight: 500;
    padding: 0;

    &:hover {
      background: #E8F3FF;
    }
  }

  .detail-card {
    background: #F3F7FB;
    border-radius: 8px;
    padding: 20px 24px;
    margin-bottom: 20px;

    .detail-row {
      display: flex;
      flex-wrap: wrap;
      gap: 20px;
      margin-bottom: 16px;

      &:last-child {
        margin-bottom: 0;
      }

      .detail-item {
        display: flex;
        align-items: center;
        min-width: 280px;

        &.detail-item-full {
          width: 100%;
          flex-direction: column;
          align-items: flex-start;

          .detail-value {
            margin-top: 8px;
            line-height: 1.6;
          }
        }
      }

      .detail-label {
        font-size: 14px;
        font-family: 'PingFang SC', sans-serif;
        font-weight: 500;
        color: #8C9BB4;
        white-space: nowrap;
      }

      .detail-value {
        font-size: 14px;
        font-family: 'PingFang SC', sans-serif;
        font-weight: 500;
        color: #1D2129;
      }
    }
  }

  .tabs-wrapper {
    ::v-deep .el-tabs__nav-wrap::after {
      height: 1px;
      background-color: #EBF2FA;
    }

    ::v-deep .el-tabs__item {
      font-size: 14px;
      font-family: 'PingFang SC', sans-serif;
      font-weight: 500;
      color: #364153;

      &.is-active {
        color: #0E76FF;
      }
    }

    ::v-deep .el-tabs__active-bar {
      background-color: #0E76FF;
    }
  }
}
</style>
